module.exports = __webpack_public_path__ + "media/images/email-5470edef6fb87d416ad1b26936e9a675.svg";